import { atom } from 'jotai';
import { AuthorizationObjectPermissions, AuthorizationObjectType } from '@kheops/graphql';
import { PackagingsByCompanyQuery } from '../queries/__generated__/packagingsByCompany.generated';
import { globalAuthorizationAtom, userAtom } from '../state';

export type CompanyPackaging = PackagingsByCompanyQuery['packaging'][number];

export const companyPackagingsAtom = atom<CompanyPackaging[]>([]);

export const refreshCompanyProductListAtom = atom<boolean>(false);
export const isWaitingForSubCatalogsSyncAtom = atom<boolean>(false);
export const isFilterDrawerOpenAtom = atom(false);

export const canEditCompanySettingsAtom = atom(
  (get) => get(userAtom).isStaff || get(globalAuthorizationAtom).some((authorization) => authorization.permission === AuthorizationObjectPermissions.CanEditCompanySettings && authorization.object === AuthorizationObjectType.Company),
);

export const canEditContractConditionsAtom = atom(
  (get) => get(userAtom).isStaff || get(globalAuthorizationAtom).some((authorization) => authorization.permission === AuthorizationObjectPermissions.CanEditContractConditions && authorization.object === AuthorizationObjectType.Company),
);

export const canEditProductAtom = atom(
  (get) => get(userAtom).isStaff || get(globalAuthorizationAtom).some((authorization) => authorization.permission === AuthorizationObjectPermissions.CanEditProduct && authorization.object === AuthorizationObjectType.Company),
);

export const canEditDeliveryZonesAtom = atom(
  (get) => get(userAtom).isStaff || get(globalAuthorizationAtom).some((authorization) => authorization.permission === AuthorizationObjectPermissions.CanEditDeliveryZones && authorization.object === AuthorizationObjectType.Company),
);

export const canEditServicesAtom = atom(
  (get) => get(userAtom).isStaff || get(globalAuthorizationAtom).some((authorization) => authorization.permission === AuthorizationObjectPermissions.CanEditServices && authorization.object === AuthorizationObjectType.Company),
);
